import { Transaction } from './transaction';

export class SelectableTransaction extends Transaction {
  selected: boolean; // used to mark checkbox checked
}
